import { render } from "./AreaStats.vue?vue&type=template&id=62e88b3e"
import script from "./AreaStats.vue?vue&type=script&lang=js"
export * from "./AreaStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__